/* eslint-disable no-console */

'use strict'

import _ from 'lodash'

import Vue from 'vue'
import Debug from 'debug'

const globalEventBus = new Vue()

export default Vue.mixin({

  computed: {

    $bus() {
      return globalEventBus
    },

  },

  methods: {

    /**
     * Programmatically navigate to route. If object then Vue Router object
     * https://router.vuejs.org/en/essentials/navigation.html
     * @param location string|object
     */
    $redirect(location) {
      this.$router.push(location)
    },

    $cleanObject(obj) {
      if (!obj) {
        return null
      }
      return JSON.parse(JSON.stringify(obj))
    },

    $toast({
      type = 'error',
      message = null
    }) {
      this.$bus.$emit('show-toast', {
        type: type,
        message: message,
      })
    },

    $confirm(message = null, title = null) {
      let me = this
      return new Promise((resolve, reject) => {
        me.$bus.$on('confirm.cancel', () => {
          reject(new Error('cancel'))
          me.$bus.$off(['confirm.cancel', 'confirm.ok'])
        })
        me.$bus.$on('confirm.ok', () => {
          resolve()
          me.$bus.$off(['confirm.cancel', 'confirm.ok'])
        })
        me.$bus.$emit('show-confirm', {
          title: title,
          message: message,
        })
      })
    },

    $alert(message, timeout = 6000) {
      this.$toast({
        type: 'warning',
        message: message,
        timeout: timeout,
      })
    },

    $error(err) {
      let me = this

      if (_.isString(err)) {
        me.$toast({
          type: 'error',
          message: err
        })
      } else if (err && err.message) {
        me.$toast({
          type: 'error',
          message: err.message
        })
      }
    },

    $debug() {
      let me = this
      let identifier = 'unknown'
      if (me._name) {
        identifier = me._name
      } else if (me.$options.__file) {
        identifier = me.$options.__file
      }
      Debug(process.env.VUE_APP_PREFIX + ':' + identifier)(...arguments)
    },

    $timeout(ms) {
      return new Promise(res => setTimeout(res, ms))
    }

  },

})
